import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { PostService } from "app/helpers/post.service";
import { environment } from "environments/environment";
import { UiService } from "app/helper-components/UiService";

@Component({
  selector: "app-createCard-modal",
  templateUrl: "./createCard-modal.component.html",
  styleUrls: ["./createCard-modal.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CreateCardModalComponent implements OnInit {
  @ViewChild("title") title;
  header_title = "To Change Title";
  error_msg = "Please enter a valid name";
  placeholder = "Name";
  subTitle;
  enableButton = true;
  showError = false;
  union_type_name = "";
  Request: any = {};
  union_type: any;

  constructor(
    private dialog: MatDialog,
    private translate: TranslateService,
    private uiService: UiService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private postService: PostService,

  ) { }

  ngOnInit(): void {  
    this.union_type_name = this.data.union_type_name;
    this.union_type = this.data.union_type;
  }

  onClickCancel() {
    this.data.onCancel();
  }

  onClickSubmit() {
    
    this.uiService.showLoading();
    //Checking for white spaces
    if (this.subTitle.trim().length != "0") {
      if(this.union_type!=""){
        this.Request = {
          "cons_circle_name": this.subTitle,
          "union_id": this.data.union_type,
          "const_id": this.data.const_id
        }  
        this.postService.post(
          environment.CREATE_CONS_CIRCLE, this.Request).subscribe((val) => {
            this.data.onSuccess(val);
            this.uiService.hideLoading();
          })
      }
      else{
        this.Request = {
            "cons_circle_id": this.data.cons_circle_id,
            "section_name": this.subTitle
            }
        this.postService.post(
          environment.CREATE_SECTION, this.Request).subscribe((val) =>{
            this.data.onSuccess(val);
            this.uiService.hideLoading();
          }
          )  
      }
    } else if (this.subTitle.trim().length == "0") {
      this.enableButton = false;
      this.showError = true;
      this.subTitle = "";
      this.title.nativeElement.focus();
    }
  }
}
